import Scene = Phaser.Scene;
import Image = Phaser.GameObjects.Image;
import {Keys} from "@/constants/key";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "@/utils/c-u";

export default class SContainer extends Phaser.GameObjects.Container {

    constructor(scene: Scene, x: number, y: number) {
        super(scene);

        this.scene = scene;
        this.x = x * CU.S;
        this.y = y * CU.S;
    }

    public setOrigin(x: number, y: number): void {
        // do nothing
    }

    public setScale(x?: number, y?: number): this {
        if (x && y) {
            return super.setScale(x * CU.S, y * CU.S);
        }
        if (x && !y) {
            return super.setScale(x * CU.S, x * CU.S);
        }
        return super.setScale(CU.S, CU.S);
    }

    protected setScaleOriginal(x?: number, y?: number): this {
        return super.setScale(x, y);
    }
}
